// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, shallowEqual } from 'react-redux';

import CommonPage from 'app/common/templates/CommonPage';
import About from 'app/common/components/About';
import Loading from 'app/components/Loader';
import getRegAvailable from 'app/selectors/getRegAvailable';


const AboutPage = () => {
  const { t } = useTranslation('about');
  const { loading, result } = useSelector(state => state.documents, shallowEqual);
  const isLoading = loading || result !== 'success';
  const regAvailable = useSelector(getRegAvailable);

  return (isLoading
    ? <Loading />
    : <CommonPage header={t('page_title', 'О приложении')}>
      <About disableAgreement={regAvailable} />
    </CommonPage>
  );
};

export default AboutPage;
